// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_wn-8";
export var editMode = "_wn-3";
export var headerRow = "_wn-a";
export var headerTitle = "_wn-b";
export var product = "_wn-1";
export var productDetails = "_wn-5";
export var productDivider = "_wn-7";
export var productImage = "_wn-2";
export var productInfo = "_wn-4";
export var productTitle = "_wn-6";
export var strikethrough = "_wn-9";
export var upsellProductsCard = "_wn-0";